import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["amountField", "customInput", "quantityField", "discountTypeField"];
  static values = {
    ticketId: Number,
    ticketName: String,
    absorbFee: Boolean,
    min: {type: Number, default: 0},
    max: {type: Number, default: null},
  };

  connect() {
    this.selectedAmount = 0;
    this.syncSubmissionFields(false);
  }

  selectAmount(event) {
    const amount = parseFloat(event.currentTarget.dataset.amount) || 0;
    const buttons = event.currentTarget.closest(".donation-amounts")?.querySelectorAll(".donation-amount-btn");
    // Toggle off: if clicking the already selected amount, unselect and clear
    if (amount > 0 && amount === this.selectedAmount) {
      this.setAmount(0);
      this.clearCustomInput();
      buttons?.forEach((btn) => btn.classList.remove("active"));
      return;
    }
    this.setAmount(amount);
    this.clearCustomInput();
    buttons?.forEach((btn) => {
      btn.classList.remove("active");
      if (parseFloat(btn.dataset.amount) === amount) btn.classList.add("active");
    });
  }

  customAmountChange() {
    if (!this.hasCustomInputTarget) return;
    const raw = this.customInputTarget.value.trim();
    const amount = raw === "" ? 0 : parseFloat(raw) || 0;
    this.setAmount(amount);
    // Unselect suggested amount buttons when user types custom amount
    this.unselectSuggestedButtons();
  }

  unselectSuggestedButtons() {
    this.element.querySelectorAll(".donation-amount-btn").forEach((btn) => btn.classList.remove("active"));
  }

  clearCustomInput() {
    if (this.hasCustomInputTarget) this.customInputTarget.value = "";
  }

  setAmount(amount) {
    if (amount < 0) amount = 0;
    // Do not clamp to min/max here: keep input and order summary in sync with what the user entered.
    // Backend validates min/max on submit and returns an error if out of range.

    this.selectedAmount = amount;
    const enabled = amount > 0;
    this.syncSubmissionFields(enabled, amount);

    const orderSummary = this.orderSummaryController;
    if (!orderSummary) return;

    if (amount > 0) {
      orderSummary.update(this.ticketIdValue, this.ticketNameValue, amount, 1, this.absorbFeeValue, 0, false,
        amount, true, false, 0, "none", null, true // isDonation: no tax on donation tickets
       );
    } else {
      orderSummary.update(this.ticketIdValue, this.ticketNameValue, 0, 0, this.absorbFeeValue, 0, false, 0, true,
        false, 0, "none", null, true // isDonation
      );
    }
  }

  get orderSummaryController() {
    return this.application.controllers.find(
      (c) => c.context.identifier === "order-summary"
    );
  }

  /** When false, hidden ticket fields stay disabled so they are not posted. */
  syncSubmissionFields(enabled, amount = 0) {
    if (this.hasQuantityFieldTarget) {
      this.quantityFieldTarget.disabled = !enabled;
    }
    if (this.hasAmountFieldTarget) {
      this.amountFieldTarget.disabled = !enabled;
      this.amountFieldTarget.value = enabled && amount > 0 ? amount.toFixed(2) : "";
    }
    if (this.hasDiscountTypeFieldTarget) {
      this.discountTypeFieldTarget.disabled = !enabled;
    }
  }
}

